export const Errors = {
  Email: 'Please enter a valid email',
  Age: 'Must be 13 years or older to sign up',
  MaxAge: 'Must be 122 years or younger to sign up',
  AccountInfoAge: 'Must be 13 years or older',
  AccountInfoMaxAge: 'Must be 122 years or younger',
  Password: 'This password does not meet the criteria. Please try again',
  Date: 'Please enter a valid birthdate (MM/DD/YYYY)',
  FName:
    'Invalid name (try complete names containing letters, dashes or apostrophes)',
  LName:
    'Invalid name (try complete names containing letters, dashes or apostrophes)',
  Required: 'This value is required',
  ImageSupport: 'File type not supported (Please use .jpg, .png, .gif)',
  FileSize: 'File size too large, limit to 5mb.',
  PhotoLimit: 'Limit of two photos per submission.',
  ImageRequired: 'Please add photos of coupon and receipt',
  FirstName:
    'Invalid name (try complete names containing letters, dashes or apostrophes)',
  LastName:
    'Invalid name (try complete names containing letters, dashes or apostrophes)',
  DateOfPurchaseError: 'Please enter a valid purchase date (MM/DD/YYYY)',
  CouponPriceError: 'Please enter a valid coupon price.',
  PurchasePriceError: 'Please enter a valid purchase price.',
  ZipError: 'Please enter a valid zip code',
  Zip: 'Please enter a valid zip code',
  TextArea: 'Please describe why you’re requesting this change',
  SelectUpdate: 'Please select a reason for this update',
  Phone: 'Invalid Phone Number',
  InvalidPassword: 'Password does not meet requirements.',
  PasswordMatch: "Passwords don't match.",
  MultipleEmail: '1 or more emails is in an incorrect format.',
  EmailPhysical: 'Please enter a valid email address',
  MessageLimit: 'Message limit exceeded upto 255 characters allowed'
};
